import React from "react";
import Mango_Color_Btn from "../../../Common_Btn/Mango_Color_Btn/Mango_Color_Btn";

import "./SmokeOrTobacco.css";

const SmokeOrTobacco = (props) => {
  const handlechange = (val) => {
    props.setSmoke(val);
    props?.handleNext();
  };

  console.log(props.smoke,'props.smoke props.smoke');
  
  return (
    <section className="SmokeOrTobacco">
      <p className="step_title">Do you smoke or chew tobacco?</p>

      <p className="note_text">
        Select <span> 'Yes' </span>if you have smoked or chewed tobacco in last
        12 months
      </p>

      <div className="btn_holder">
        <div className="yes_btn_holder">
          <Mango_Color_Btn
            extraClass={props.smoke === 1 ? "active" : ""}
            btn_name="Yes"
            onClick={() => {
              handlechange(1);
            }}
          />
        </div>
        <div className="no_btn_holder">
          <Mango_Color_Btn
            extraClass={props.smoke === 0 ? "active" : ""}
            btn_name="No"
            onClick={() => {
              handlechange(0);
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SmokeOrTobacco;
